import { createSlice, createSelector } from "@reduxjs/toolkit";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap, map, catchError, exhaustMap } from "rxjs/operators";
import { BonusStages } from "@nxplatform/helpers/common/bonus-stages.promotions";
import { BonusesBonusTypes, BonusTypes, BonusEvents } from "@nxplatform/platform-entities/bonuses/bonus-entities";
var PromotionsTypes = /* @__PURE__ */ ((PromotionsTypes2) => {
  PromotionsTypes2[PromotionsTypes2["bonus"] = 1] = "bonus";
  PromotionsTypes2[PromotionsTypes2["freespins"] = 2] = "freespins";
  PromotionsTypes2[PromotionsTypes2["freebets"] = 3] = "freebets";
  return PromotionsTypes2;
})(PromotionsTypes || {});
const CUSTOMER_PROMOTION_FEATURE_KEY = "customerPromotion";
const initialCustomerPromotionState = {
  entities: [],
  relations: null,
  history: [],
  loaded: false,
  loadedHistory: false,
  error: null,
  page: null,
  pageHistory: null,
  pageLastHistory: null,
  limit: null,
  total: null,
  totalHistory: null
};
const customerPromotionSlice = createSlice({
  name: CUSTOMER_PROMOTION_FEATURE_KEY,
  initialState: initialCustomerPromotionState,
  reducers: {
    getCustomerPromotionStart: (state, action) => {
    },
    getCustomerPromotionSuccess: (state, action) => {
      state.loaded = true;
      state.entities = action.payload.items;
      state.relations = action.payload.relations;
      state.total = action.payload.totalCount;
      state.page = action.payload.page;
    },
    addCustomerPromotion: (state, action) => {
      const { id, bonusId } = action.payload;
      const bId = id || bonusId;
      const newBonus = state.entities.every((bonus) => bonus.id !== bId);
      if (newBonus) {
        state.entities.push({ ...action.payload, bonusId: bId });
      }
    },
    updateCustomerPromotionSuccess: (state, action) => {
      const { bonusId, id } = action.payload || {};
      const bId = id || bonusId;
      state.entities = state.entities.map((bonus) => {
        if (Number(bonus.bonusId) === bId) {
          return { ...bonus, ...action.payload, bonusId: bId };
        }
        return bonus;
      });
    },
    deleteCustomerPromotionSuccess: (state, action) => {
      const { bonusId, id } = action.payload || {};
      const bId = id || bonusId;
      if (!state.entities) return;
      const findIndex = state.entities.findIndex(
        (bonus) => bonus.bonusId === bId
      );
      if (findIndex !== -1) {
        state.entities.splice(findIndex, 1);
      }
    },
    getCustomerPromotionFailure: (state, action) => {
      state.error = action.payload;
    },
    getCustomerPromotionHistoryListStart: (state, action) => {
      state.loadedHistory = false;
    },
    getCustomerPromotionHistoryListSuccess: (state, action) => {
      state.loadedHistory = true;
      state.pageHistory = action.payload.data.page;
      state.pageLastHistory = action.payload.data.lastPage;
      state.totalHistory = action.payload.data.totalCount;
      if (action.payload.overwrite) {
        state.history = action.payload.data.items;
        return;
      }
      state.history = [...state.history, ...action.payload.data.items];
    },
    getCustomerPromotionHistoryListFailure: (state, action) => {
    },
    getCustomerPromotionCancelStart: (state, action) => {
      console.log("cancel start");
    },
    getCustomerPromotionCancelSuccess: (state, action) => {
      const findIndex = state.entities.findIndex(
        (bonus) => bonus.bonusId === action.payload.bonusId
      );
      if (findIndex !== -1) {
        state.entities.splice(findIndex, 1);
      }
    },
    getCustomerPromotionCancelFailure: (state, action) => {
      console.log("cancel error");
    },
    customerPromotionActivateStart: (state, action) => {
    },
    customerPromotionActivateSuccess: (state, action) => {
      const activeBonus = state.entities.find(
        (bonus) => bonus.bonusId === action.payload
      );
      activeBonus.stage = BonusStages.activated;
    },
    customerPromotionActivateFailure: (state, action) => {
    },
    customerPromotionActivateFreespinsStart: (state, action) => {
    },
    customerPromotionActivateFreespinsSuccess: (state, action) => {
      const activeFreespins = state.entities.find(
        (fs) => fs.bonusId === action.payload
      );
      activeFreespins.stage = BonusStages.activated;
    },
    customerPromotionActivateFreespinsFailure: (state, action) => {
      state.error = action.payload;
    },
    getCustomerPromotionCreditRequestStart: (state, action) => {
    },
    getCustomerPromotionCreditRequestSuccess: (state, action) => {
    },
    getCustomerPromotionCreditRequestFailure: (state, action) => {
    },
    customerClearPromotionsState: (state) => {
      state.entities = initialCustomerPromotionState.entities;
    },
    customerClearPromotionsHistoryState: (state) => {
      state.history = initialCustomerPromotionState.history;
      state.pageHistory = initialCustomerPromotionState.pageHistory;
      state.pageLastHistory = initialCustomerPromotionState.pageLastHistory;
      state.totalHistory = initialCustomerPromotionState.totalHistory;
      state.loadedHistory = initialCustomerPromotionState.loadedHistory;
    },
    customerPromotionActivateBonusBuyStart: (state, action) => {
    },
    customerPromotionActivateBonusBuySuccess: (state, action) => {
      const activeBonusBuy = state.entities.find(
        (bonus) => bonus.bonusId === action.payload
      );
      activeBonusBuy.stage = BonusStages.activated;
    },
    customerPromotionActivateBonusBuyFailure: (state, action) => {
      state.error = action.payload;
    },
    getCustomerPromotionBonusBuyCancelStart: (state, action) => {
    },
    getCustomerPromotionBonusBuyCancelSuccess: (state, action) => {
      const findIndex = state.entities.findIndex(
        (bonus) => bonus.bonusId === action.payload
      );
      if (findIndex !== -1) {
        state.entities.splice(findIndex, 1);
      }
    },
    getCustomerPromotionBonusBuyCancelFailure: (state, action) => {
    }
  }
});
const customerPromotionReducer = customerPromotionSlice.reducer;
const {
  getCustomerPromotionStart,
  getCustomerPromotionSuccess,
  getCustomerPromotionFailure,
  getCustomerPromotionHistoryListStart,
  getCustomerPromotionHistoryListSuccess,
  getCustomerPromotionHistoryListFailure,
  getCustomerPromotionCancelStart,
  getCustomerPromotionCancelSuccess,
  getCustomerPromotionCancelFailure,
  customerPromotionActivateStart,
  customerPromotionActivateSuccess,
  customerPromotionActivateFailure,
  customerPromotionActivateFreespinsStart,
  customerPromotionActivateFreespinsSuccess,
  customerPromotionActivateFreespinsFailure,
  customerClearPromotionsState,
  customerClearPromotionsHistoryState,
  updateCustomerPromotionSuccess,
  deleteCustomerPromotionSuccess,
  addCustomerPromotion,
  getCustomerPromotionCreditRequestStart,
  getCustomerPromotionCreditRequestSuccess,
  getCustomerPromotionCreditRequestFailure,
  customerPromotionActivateBonusBuyStart,
  customerPromotionActivateBonusBuySuccess,
  customerPromotionActivateBonusBuyFailure,
  getCustomerPromotionBonusBuyCancelStart,
  getCustomerPromotionBonusBuyCancelSuccess,
  getCustomerPromotionBonusBuyCancelFailure
} = customerPromotionSlice.actions;
const getCustomerPromotionState = (rootState) => rootState[CUSTOMER_PROMOTION_FEATURE_KEY];
const selectCustomerPromotionEntities = createSelector(
  getCustomerPromotionState,
  (s) => s.entities
);
const selectCustomerBonusBuysCount = createSelector(
  getCustomerPromotionState,
  (s) => s.entities.filter(
    (bonus) => bonus.bonusType === BonusesBonusTypes.BonusBuy
  ).length
);
const selectCustomerFreeSpinsAmount = createSelector(
  getCustomerPromotionState,
  (s) => s.entities.filter((bonus) => bonus.bonusType === BonusesBonusTypes.Freespins).reduce((acc, bonus) => acc + bonus.bonusAmount, 0)
);
const selectCustomerPromotionRelations = createSelector(
  getCustomerPromotionState,
  (s) => s.relations
);
const selectCustomerPromotionRelationsLeagues = createSelector(
  getCustomerPromotionState,
  (s, leagueId) => leagueId || [],
  (s, leagueId) => leagueId.map((league) => {
    return s.relations.leagues[league] || {};
  })
);
const selectCustomerPromotionRelationsEvents = createSelector(
  getCustomerPromotionState,
  (s, eventId) => eventId,
  ({ relations }, eventId) => {
    return { event: relations.events[eventId], league: relations.leagues[relations.events[eventId].league_id] };
  }
);
const selectCustomerPromotionRelationsEventsCompetitors = createSelector(
  getCustomerPromotionState,
  (s, competitorId) => competitorId,
  ({ relations }, competitorId) => {
    const findTeam = relations.competitors[competitorId];
    return findTeam.name || "#";
  }
);
const selectCustomerClaimedEntities = createSelector(
  getCustomerPromotionState,
  (s) => s.entities.filter((bonus) => bonus.stage === BonusStages.wagerDone).filter((bonus) => bonus.originBonusType !== BonusesBonusTypes.RandomPrize)
);
const selectCustomerActivePromotionEntities = createSelector(
  getCustomerPromotionState,
  (s) => s.entities.filter((bonus) => bonus.stage === BonusStages.activated).filter((bonus) => bonus.originBonusType !== BonusesBonusTypes.RandomPrize)
);
const selectCustomerInactivePromotionEntities = createSelector(
  getCustomerPromotionState,
  (s) => s.entities.filter((bonus) => bonus.stage === BonusStages.notActivated).filter((bonus) => bonus.originBonusType !== BonusesBonusTypes.RandomPrize)
);
const selectCustomerPromotionEntitiesWithoutWof = createSelector(
  getCustomerPromotionState,
  (s) => s.entities.filter((bonus) => bonus.originBonusType !== BonusesBonusTypes.RandomPrize)
);
const selectCustomerPromotionHistoryEntities = createSelector(
  getCustomerPromotionState,
  (s) => s.history
);
const selectCustomerPromotionLoaded = createSelector(
  getCustomerPromotionState,
  (s) => s.loaded
);
const selectCustomerPromotionLoadedHistory = createSelector(
  getCustomerPromotionState,
  (s) => s.loadedHistory
);
const selectCustomerPromotionError = createSelector(
  getCustomerPromotionState,
  (s) => s.error
);
const selectCustomerPromotionTotal = createSelector(
  getCustomerPromotionState,
  (s) => s.total
);
const selectCustomerPromotionTotalHistory = createSelector(
  getCustomerPromotionState,
  (s) => s.totalHistory
);
const selectCustomerPromotionPage = createSelector(
  getCustomerPromotionState,
  (s) => s.page
);
const selectCustomerPromotionPageHistory = createSelector(
  getCustomerPromotionState,
  (s) => s.pageHistory
);
const selectCustomerPromotionPageLastHistory = createSelector(
  getCustomerPromotionState,
  (s) => s.pageLastHistory
);
const selectCustomerPromotionsAvailableCount = createSelector(
  getCustomerPromotionState,
  (s) => {
    var _a, _b;
    return (_b = (_a = s.entities) == null ? void 0 : _a.filter((bonus) => bonus.originBonusType !== BonusesBonusTypes.RandomPrize)) == null ? void 0 : _b.length;
  }
);
const selectHasCustomerRandomPrize = createSelector(
  selectCustomerPromotionEntities,
  (bonuses) => !!bonuses.length && bonuses.some(
    (item) => item.originBonusType === BonusesBonusTypes.RandomPrize || item.bonusType === BonusesBonusTypes.RandomPrize
  )
);
const filterWelcomeBonus = (item) => (item == null ? void 0 : item.type) === BonusTypes.sports && (item == null ? void 0 : item.event) === BonusEvents.FirstDeposit;
const filterIsBonusNotSpent = (item) => item.wagedAmount < item.wagerRequirement + item.bonusAmount;
const selectCustomerPromotionsBonusesLastRewards = createSelector(
  getCustomerPromotionState,
  (s) => {
    const { history } = s;
    return (history == null ? void 0 : history.filter(
      (item) => item.stage === BonusStages.wagerDone && filterWelcomeBonus(item) && filterIsBonusNotSpent(item)
    )) || [];
  }
);
const selectCustomerPromotionsWelcomeBonuses = createSelector(
  selectCustomerPromotionEntities,
  (items) => items.filter(filterWelcomeBonus)
);
const promotionListEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getCustomerPromotionStart.type),
  switchMap((action) => Api.promotion.getList(action.payload).pipe(
    map((data) => getCustomerPromotionSuccess(data)),
    catchError((err) => of(getCustomerPromotionFailure(err)))
  ))
);
const promotionList = (type, stages) => ({
  type: getCustomerPromotionStart.type,
  payload: { type: type ?? null, stages: stages ?? null }
});
const promotionCancelEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getCustomerPromotionCancelStart.type),
  exhaustMap((action) => Api.promotion.cancel(action.payload).pipe(
    map(() => getCustomerPromotionCancelSuccess(action.payload)),
    catchError((err) => of(getCustomerPromotionCancelFailure(err)))
  ))
);
const promotionCancel = (cancelRequest) => ({
  type: getCustomerPromotionCancelStart.type,
  payload: cancelRequest
});
const promotionActivateEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(customerPromotionActivateStart.type),
  exhaustMap((action) => Api.promotion.activate(action.payload).pipe(
    map(() => customerPromotionActivateSuccess(action.payload)),
    catchError((err) => of(customerPromotionActivateFailure(err)))
  ))
);
const promotionActivate = (id) => ({
  type: customerPromotionActivateStart.type,
  payload: id
});
const promotionHistoryList = (filters, overwrite = true) => ({
  type: getCustomerPromotionHistoryListStart.type,
  payload: { filters, overwrite }
});
const promotionHistoryListEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getCustomerPromotionHistoryListStart.type),
  switchMap(
    (action) => Api.promotion.getHisoryList(action.payload.filters).pipe(
      map((data) => getCustomerPromotionHistoryListSuccess({
        data,
        overwrite: action.payload.overwrite
      })),
      catchError((err) => of(getCustomerPromotionHistoryListFailure(err)))
    )
  )
);
const promotionActivateFreespinsEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(customerPromotionActivateFreespinsStart.type),
  exhaustMap((action) => Api.promotion.activateFreespins(action.payload).pipe(
    map(() => customerPromotionActivateFreespinsSuccess(action.payload)),
    catchError((err) => of(customerPromotionActivateFreespinsFailure(err)))
  ))
);
const promotionActivateFreespins = (id) => ({
  type: customerPromotionActivateFreespinsStart.type,
  payload: id
});
const promotionActivateBonusBuyEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(customerPromotionActivateBonusBuyStart.type),
  exhaustMap((action) => Api.promotion.activateBonusBuy(action.payload).pipe(
    map(() => customerPromotionActivateBonusBuySuccess(action.payload)),
    catchError((err) => of(customerPromotionActivateBonusBuyFailure(err)))
  ))
);
const promotionActivateBonusBuy = (id) => ({
  type: customerPromotionActivateBonusBuyStart.type,
  payload: id
});
const promotionBonusBuyCancelEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getCustomerPromotionBonusBuyCancelStart.type),
  exhaustMap((action) => Api.promotion.cancelBonusBuy(action.payload).pipe(
    map(() => getCustomerPromotionBonusBuyCancelSuccess(action.payload)),
    catchError((err) => of(getCustomerPromotionBonusBuyCancelFailure(err)))
  ))
);
const promotionBonusBuyCancel = (id) => ({
  type: getCustomerPromotionBonusBuyCancelStart.type,
  payload: id
});
const promotionRequestCreditEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getCustomerPromotionCreditRequestStart.type),
  exhaustMap((action) => Api.promotion.requestCredit(action.payload).pipe(
    map(() => getCustomerPromotionCreditRequestSuccess(action.payload)),
    catchError((err) => of(getCustomerPromotionCreditRequestFailure(err)))
  ))
);
const promotionRequestCredit = (creditRequest) => ({
  type: getCustomerPromotionCreditRequestStart.type,
  payload: creditRequest
});
export {
  CUSTOMER_PROMOTION_FEATURE_KEY,
  PromotionsTypes,
  addCustomerPromotion,
  customerClearPromotionsHistoryState,
  customerClearPromotionsState,
  customerPromotionActivateBonusBuyFailure,
  customerPromotionActivateBonusBuyStart,
  customerPromotionActivateBonusBuySuccess,
  customerPromotionActivateFailure,
  customerPromotionActivateFreespinsFailure,
  customerPromotionActivateFreespinsStart,
  customerPromotionActivateFreespinsSuccess,
  customerPromotionActivateStart,
  customerPromotionActivateSuccess,
  customerPromotionReducer,
  customerPromotionSlice,
  deleteCustomerPromotionSuccess,
  getCustomerPromotionBonusBuyCancelFailure,
  getCustomerPromotionBonusBuyCancelStart,
  getCustomerPromotionBonusBuyCancelSuccess,
  getCustomerPromotionCancelFailure,
  getCustomerPromotionCancelStart,
  getCustomerPromotionCancelSuccess,
  getCustomerPromotionCreditRequestFailure,
  getCustomerPromotionCreditRequestStart,
  getCustomerPromotionCreditRequestSuccess,
  getCustomerPromotionFailure,
  getCustomerPromotionHistoryListFailure,
  getCustomerPromotionHistoryListStart,
  getCustomerPromotionHistoryListSuccess,
  getCustomerPromotionStart,
  getCustomerPromotionState,
  getCustomerPromotionSuccess,
  initialCustomerPromotionState,
  promotionActivate,
  promotionActivateBonusBuy,
  promotionActivateBonusBuyEpic,
  promotionActivateEpic,
  promotionActivateFreespins,
  promotionActivateFreespinsEpic,
  promotionBonusBuyCancel,
  promotionBonusBuyCancelEpic,
  promotionCancel,
  promotionCancelEpic,
  promotionHistoryList,
  promotionHistoryListEpic,
  promotionList,
  promotionListEpic,
  promotionRequestCredit,
  promotionRequestCreditEpic,
  selectCustomerActivePromotionEntities,
  selectCustomerBonusBuysCount,
  selectCustomerClaimedEntities,
  selectCustomerFreeSpinsAmount,
  selectCustomerInactivePromotionEntities,
  selectCustomerPromotionEntities,
  selectCustomerPromotionEntitiesWithoutWof,
  selectCustomerPromotionError,
  selectCustomerPromotionHistoryEntities,
  selectCustomerPromotionLoaded,
  selectCustomerPromotionLoadedHistory,
  selectCustomerPromotionPage,
  selectCustomerPromotionPageHistory,
  selectCustomerPromotionPageLastHistory,
  selectCustomerPromotionRelations,
  selectCustomerPromotionRelationsEvents,
  selectCustomerPromotionRelationsEventsCompetitors,
  selectCustomerPromotionRelationsLeagues,
  selectCustomerPromotionTotal,
  selectCustomerPromotionTotalHistory,
  selectCustomerPromotionsAvailableCount,
  selectCustomerPromotionsBonusesLastRewards,
  selectCustomerPromotionsWelcomeBonuses,
  selectHasCustomerRandomPrize,
  updateCustomerPromotionSuccess
};
